module.exports = __webpack_public_path__ + "static/media/carta_87.7aee97f4.jpg";